<div class="validation-warning-modal">
  <div class="title-section">
    <div class="icon-circle">
      <img src="assets/images/virtusa-icons/warning.svg" alt="Warning" />
    </div>
    <div class="content">
      <h2 class="title">{{ configs.title }}</h2>
      <p class="subtitle">{{ configs.subTitle }}</p>
    </div>
  </div>

  <div class="action-div w-100"  *ngIf="configs.requiredAction !==''">
    <span class="general-text-highlighted">Action Required: </span>
    <span class="general-text"> {{ configs.requiredAction }}</span>
  </div>

   <div class="action-div w-100"  *ngIf="configs?.errorMsg && configs.errorMsg !==''">
    <span class="general-text" *ngIf="!isOrderedList"> {{ configs.errorMsg }}</span>
    <div *ngIf="isOrderedList">
      <span class="general-text" *ngIf="errorMsgIntro">{{ errorMsgIntro }}</span>
      <ol class="general-text">
        <li *ngFor="let item of errorMsgItems">{{ item }}</li>
      </ol>
    </div>
  </div>

  <div class="w-100">
    <app-accordion-content
      [sections]="configs.data"
    ></app-accordion-content>
  </div>

  <div class="tip"  *ngIf="configs.tip !==''">
    <img src="assets/images/virtusa-icons/tip.svg" alt="tip" />
    <span class="general-text-highlighted">Tip: </span
    ><span class="general-text">{{ configs.tip }}</span>
  </div>

  <div class="modal-footer w-100">
    <button
      type="button"
      class="btn  btn-accello-primary-light d-block"
      (click)="activeModal.dismiss('Cross click')"
    >
    {{ configs.buttonText}}
    </button>
  </div>
</div>
